import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, } from "react-bootstrap";
import { Link, } from "react-router-dom";
import {
    FaUsers, FaWallet, FaGift, FaTrophy, FaArrowUp,
    FaCoins, FaCrown, FaBolt, FaTicketAlt, FaGem,
    FaChartPie, FaEllipsisH,
    FaAngleRight, FaUserShield
} from "react-icons/fa";
import { Chart, registerables } from "chart.js";


Chart.register(...registerables);

const STATS = [
    { label: "Total Users", value: "52", sub: "+14% this month", Icon: FaUsers, color: "stat-blue" },
    { label: "Total Cashback", value: "₹12.4L", sub: "+26% growth", Icon: FaWallet, color: "stat-cyan" },
    { label: "Lucky Winners", value: "1,240", sub: "+11% rewards", Icon: FaGift, color: "stat-violet" },
    { label: "Reward Pool", value: "₹48L", sub: "+19% active pool", Icon: FaTrophy, color: "stat-amber" },
];

const PROGRESS_ITEMS = [
    { label: "Cashback Distribution", value: 82, color: "#00C2FF" },
    { label: "Lucky Draw Activity", value: 74, color: "#7B61FF" },
    { label: "VIP Reward Users", value: 92, color: "#00E5B0" },
];

const QUICK_ACTIONS = [
    { label: "Add Cashback", Icon: FaCoins, cls: "qa-cyan" },
    { label: "Start Draw", Icon: FaBolt, cls: "qa-violet" },
    { label: "VIP Winners", Icon: FaCrown, cls: "qa-amber" },
    { label: "Gem Rewards", Icon: FaGem, cls: "qa-teal" },
    { label: "Manage Users", Icon: FaUserShield, cls: "qa-rose" },
    { label: "View Reports", Icon: FaChartPie, cls: "qa-blue" },
];

const WINNERS = [
    { initials: "AK", name: "Arun Kumar", reward: "iPhone 15", ticket: "#SAR1201", cashback: "₹12,000", status: "Delivered", sBg: "success" },
    { initials: "RK", name: "Rahul Kumar", reward: "Smart TV", ticket: "#SAR1452", cashback: "₹8,000", status: "Pending", sBg: "warning" },
    { initials: "VS", name: "Vijay Singh", reward: "Bike", ticket: "#SAR2400", cashback: "₹18,000", status: "Processing", sBg: "info" },
    { initials: "PM", name: "Priya Mehta", reward: "Laptop", ticket: "#SAR2710", cashback: "₹22,000", status: "Delivered", sBg: "success" },
    { initials: "SK", name: "Suresh K.", reward: "Headphones", ticket: "#SAR3100", cashback: "₹4,500", status: "Pending", sBg: "warning" },
];

export default function AdminHome() {
    const donutRef = useRef(null);
    const lineRef = useRef(null);
    const chartObjs = useRef([]);
    const [time, setTime] = useState(new Date());
    const [counter, setCount] = useState({ users: 0, cashback: 0, winners: 0, pool: 0 });


    /* live clock */
    useEffect(() => {
        const t = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(t);
    }, []);

    /* count-up */
    useEffect(() => {
        const targets = { users: 52, cashback: 124, winners: 1240, pool: 480 };
        const duration = 1400;
        const step = 16;
        const increments = Object.fromEntries(
            Object.entries(targets).map(([k, v]) => [k, v / (duration / step)])
        );
        let current = { users: 0, cashback: 0, winners: 0, pool: 0 };
        const id = setInterval(() => {
            let done = true;
            Object.keys(targets).forEach(k => {
                current[k] = Math.min(current[k] + increments[k], targets[k]);
                if (current[k] < targets[k]) done = false;
            });
            setCount({ ...current });
            if (done) clearInterval(id);
        }, step);
        return () => clearInterval(id);
    }, []);

    /* charts */
    useEffect(() => {
        chartObjs.current.forEach(c => c?.destroy());
        chartObjs.current = [];

        /* donut */
        if (donutRef.current) {
            const ctx = donutRef.current.getContext("2d");
            const c = new Chart(ctx, {
                type: "doughnut",
                data: {
                    labels: ["Cashback Released", "Lucky Draw", "VIP Rewards", "Pending"],
                    datasets: [{
                        data: [38, 27, 22, 13],
                        backgroundColor: ["#00C2FF", "#7B61FF", "#00E5B0", "#FFB347"],
                        borderWidth: 0,
                        hoverOffset: 8,
                    }],
                },
                options: {
                    cutout: "72%",
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            callbacks: { label: ctx => ` ${ctx.label}: ${ctx.parsed}%` },
                        },
                    },
                },
            });
            chartObjs.current.push(c);
        }

        /* line */
        if (lineRef.current) {
            const ctx = lineRef.current.getContext("2d");
            const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const mkGrad = (color1, color2) => {
                const g = ctx.createLinearGradient(0, 0, 0, 220);
                g.addColorStop(0, color1);
                g.addColorStop(1, color2);
                return g;
            };
            const c = new Chart(ctx, {
                type: "line",
                data: {
                    labels,
                    datasets: [
                        {
                            label: "Cashback",
                            data: [4.2, 5.8, 6.1, 7.4, 8.0, 9.3, 10.1, 11.2, 10.8, 11.9, 12.4, 13.2],
                            borderColor: "#00C2FF",
                            backgroundColor: mkGrad("rgba(0,194,255,0.25)", "rgba(0,194,255,0)"),
                            fill: true, tension: 0.45, borderWidth: 2.5, pointRadius: 0, pointHoverRadius: 5,
                        },
                        {
                            label: "Reward Pool",
                            data: [20, 24, 26, 29, 31, 34, 36, 38, 40, 42, 45, 48],
                            borderColor: "#7B61FF",
                            backgroundColor: mkGrad("rgba(123,97,255,0.20)", "rgba(123,97,255,0)"),
                            fill: true, tension: 0.45, borderWidth: 2.5, pointRadius: 0, pointHoverRadius: 5,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: { mode: "index", intersect: false },
                    scales: {
                        x: { grid: { color: "rgba(0,194,255,0.07)" }, ticks: { color: "#A9B4C7", font: { size: 11 } } },
                        y: { grid: { color: "rgba(0,194,255,0.07)" }, ticks: { color: "#A9B4C7", font: { size: 11 }, callback: v => `₹${v}L` }, border: { dash: [4, 4] } },
                    },
                    plugins: { legend: { display: false }, tooltip: { backgroundColor: "#131B2E", borderColor: "rgba(0,194,255,0.3)", borderWidth: 1, titleColor: "#F5F7FA", bodyColor: "#A9B4C7" } },
                },
            });
            chartObjs.current.push(c);
        }

        return () => chartObjs.current.forEach(c => c?.destroy());
    }, []);

    const fmt = (val, type) => {
        if (type === "cashback") return `₹${Math.round(val / 10) / 10}L`;
        if (type === "pool") return `₹${Math.round(val / 10) / 10}L`;
        return Math.round(val).toLocaleString("en-IN");
    };

    const statsDisplay = [
        { ...STATS[0], val: fmt(counter.users, "users") },
        { ...STATS[1], val: fmt(counter.cashback, "cashback") },
        { ...STATS[2], val: fmt(counter.winners, "winners") },
        { ...STATS[3], val: fmt(counter.pool, "pool") },
    ];

    const pieRef = useRef(null);

    useEffect(() => {

        if (!pieRef.current) return;

        const pieChart = new Chart(pieRef.current, {
            type: "doughnut",

            data: {
                labels: [
                    "Regular Users",
                    "Premium Users",
                    "VIP Users"
                ],

                datasets: [
                    {
                        data: [55, 30, 15],

                        backgroundColor: [
                            "#00C2FF",
                            "#7B61FF",
                            "#19D3A2"
                        ],

                        borderWidth: 0,

                        hoverOffset: 8
                    }
                ]
            },

            options: {

                responsive: true,

                maintainAspectRatio: false,

                cutout: "68%",

                plugins: {

                    legend: {
                        display: false
                    }
                }
            }
        });

        return () => {
            pieChart.destroy();
        };

    }, []);

    return (
        <>
            <div className="breadcrumb-bar mb-2 mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/admin/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            {/* <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span> */}

                            {/* <span
                                className="breadcrumb-link inactive"
                                onClick={() => navigate("/admin/addproject")}
                            >
                                Add Project
                            </span> */}
                        </div>

                        {/* <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/projects")}
                        >
                            <i className="bi bi-list-ul me-2"></i>
                            Projectlist
                        </button> */}

                    </div>
                </div>
            </div>

            <div className="cb-dashboard">

                {/* ambient blobs */}
                <div className="cb-blob cb-blob-1" />
                <div className="cb-blob cb-blob-2" />
                <div className="cb-blob cb-blob-3" />

                <Container fluid className="px-3 px-md-4">

                    {/* top --- >  */}
                    {/* <div className="cb-topbar">
                    <div>
                        <span className="cb-brand-tag">SAR SERVICES</span>
                        <h1 className="cb-title">Digital Cashback<br className="d-none d-md-block" /> Control Center</h1>
                        <p className="cb-subtitle">Smart lucky draw management with real-time cashback analytics.</p>
                    </div>
                    <div className="cb-topbar-right">
                        <div className="cb-clock">
                            <FaCalendarAlt className="me-2 cb-clock-icon" />
                            {time.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                            &nbsp;&nbsp;
                            {time.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
                        </div>
                        <div className="cb-topbar-actions">
                            <button className="cb-icon-btn" aria-label="Search"><FaSearch /></button>
                            <button className="cb-icon-btn notify" aria-label="Notifications"><FaBell /><span className="notif-dot" /></button>
                            <button className="cb-launch-btn">
                                <FaBolt className="me-2" />Launch Lucky Draw
                            </button>
                        </div>
                    </div>
                </div> */}

                    {/* cards -- > */}
                    <Row className="g-3 mb-4">
                        {statsDisplay.map(({ label, val, sub, Icon, color }, i) => (
                            <Col key={i} xl={3} lg={6} sm={6} xs={12}>
                                <div className={`cb-stat-card ${color}`}>
                                    <div className="cb-stat-icon-wrap"><Icon /></div>
                                    <div className="cb-stat-body">
                                        <span className="cb-stat-label">{label}</span>
                                        <h3 className="cb-stat-value">{val}</h3>
                                        <span className="cb-stat-growth"><FaArrowUp className="me-1" />{sub}</span>
                                    </div>
                                    <div className="cb-stat-shine" />
                                </div>
                            </Col>
                        ))}
                    </Row>

                    {/* Middle row -- > */}
                    <Row className="g-3 mb-4">

                        {/* progress */}
                        <Col xl={5} lg={12}>
                            <div className="cb-card h-100">
                                <div className="cb-card-header">
                                    <div>
                                        <h4 className="cb-card-title">Reward Analytics</h4>
                                        <span className="cb-card-sub">Digital cashback performance</span>
                                    </div>
                                    <span className="cb-live-badge"><span className="live-dot" />LIVE</span>
                                </div>

                                <div className="donut-area">
                                    <div className="donut-wrap">
                                        <canvas ref={donutRef} aria-label="Reward distribution donut chart" role="img">
                                            Cashback 38%, Lucky Draw 27%, VIP 22%, Pending 13%.
                                        </canvas>
                                        <div className="donut-center">
                                            <span className="donut-pct">84%</span>
                                            <span className="donut-lbl">Success</span>
                                        </div>
                                    </div>
                                    <div className="donut-legend">
                                        {["Cashback Released", "Lucky Draw", "VIP Rewards", "Pending"].map((l, i) => (
                                            <div key={i} className="legend-item">
                                                <span className="legend-dot" style={{ background: ["#00C2FF", "#7B61FF", "#00E5B0", "#FFB347"][i] }} />
                                                <span>{l}</span>
                                                <span className="legend-val">{[38, 27, 22, 13][i]}%</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="cb-progress-list">
                                    {PROGRESS_ITEMS.map(({ label, value, color }, i) => (
                                        <div key={i} className="cb-prog-item">
                                            <div className="cb-prog-head">
                                                <span>{label}</span><span className="cb-prog-pct">{value}%</span>
                                            </div>
                                            <div className="cb-prog-track">
                                                <div className="cb-prog-fill" style={{ width: `${value}%`, background: color }} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>

                        {/* Line chart */}
                        <Col xl={7} lg={12}>
                            <div className="cb-card h-100">
                                <div className="cb-card-header">
                                    <div>
                                        <h4 className="cb-card-title">Growth Overview</h4>
                                        <span className="cb-card-sub">
                                            Monthly cashback & reward pool trends
                                        </span>
                                    </div>

                                    <div className="chart-legend">
                                        <span className="cl-item">
                                            <span
                                                className="cl-dot"
                                                style={{ background: "#00C2FF" }}
                                            />
                                            Cashback
                                        </span>

                                        <span className="cl-item">
                                            <span
                                                className="cl-dot"
                                                style={{ background: "#7B61FF" }}
                                            />
                                            Reward Pool
                                        </span>
                                    </div>
                                </div>

                                {/*  */}
                                <div
                                    style={{
                                        position: "relative",
                                        height: "280px",
                                        marginTop: "1rem"
                                    }}
                                >
                                    <canvas
                                        ref={lineRef}
                                        aria-label="Monthly cashback and reward pool line chart"
                                        role="img"
                                    >
                                        Monthly growth from January to December.
                                    </canvas>
                                </div>

                                {/* pie chart */}
                                {/* <div className="cb-pie-wrapper">
                                <div className="cb-pie-left">
                                    <h5 className="pie-title">Reward Distribution</h5>
                                    <p className="pie-sub">
                                        Cashback split across user categories
                                    </p>

                                    <div className="pie-legends">
                                        <div className="pie-leg-item">
                                            <span
                                                className="pie-color"
                                                style={{ background: "#00C2FF" }}
                                            />
                                            Regular Users
                                        </div>

                                        <div className="pie-leg-item">
                                            <span
                                                className="pie-color"
                                                style={{ background: "#7B61FF" }}
                                            />
                                            Premium Users
                                        </div>

                                        <div className="pie-leg-item">
                                            <span
                                                className="pie-color"
                                                style={{ background: "#19D3A2" }}
                                            />
                                            VIP Users
                                        </div>
                                    </div>
                                </div>

                                <div className="cb-pie-chart">
                                    <canvas
                                        ref={pieRef}
                                        aria-label="Reward distribution pie chart"
                                        role="img"
                                    />
                                </div>
                            </div> */}

                                {/* mini cards */}
                                <div className="cb-mini-metrics">
                                    <div className="cb-mini-m">
                                        <FaCoins className="mm-icon cyan" />
                                        <div>
                                            <h5>₹8.4L</h5>
                                            <p>Released</p>
                                        </div>
                                    </div>

                                    <div className="cb-mini-m">
                                        <FaBolt className="mm-icon violet" />
                                        <div>
                                            <h5>1,240</h5>
                                            <p>Active Draws</p>
                                        </div>
                                    </div>

                                    <div className="cb-mini-m">
                                        <FaGem className="mm-icon teal" />
                                        <div>
                                            <h5>₹1.2L</h5>
                                            <p>Pending</p>
                                        </div>
                                    </div>

                                    <div className="cb-mini-m">
                                        <FaCrown className="mm-icon amber" />
                                        <div>
                                            <h5>340</h5>
                                            <p>VIP Users</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                    </Row>

                    {/* Bottom  -- >  */}
                    <Row className="g-3 mb-4">

                        {/* Recent Winners */}
                        <Col xl={8} lg={12}>
                            <div className="cb-card">
                                <div className="cb-card-header mb-3">
                                    <div>
                                        <h4 className="cb-card-title">Recent Winners</h4>
                                        <span className="cb-card-sub">Latest reward transactions</span>
                                    </div>
                                    <button className="cb-view-btn">View All <FaAngleRight className="ms-1" /></button>
                                </div>
                                <div className="table-responsive">
                                    <table className="cb-table w-100">
                                        <thead>
                                            <tr>
                                                <th>User</th>
                                                <th>Reward</th>
                                                <th>Ticket</th>
                                                <th>Cashback</th>
                                                <th>Status</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {WINNERS.map(({ initials, name, reward, ticket, cashback, status, sBg }, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        <div className="winner-cell">
                                                            <div className={`winner-av av-${sBg}`}>{initials}</div>
                                                            <span>{name}</span>
                                                        </div>
                                                    </td>
                                                    <td>{reward}</td>
                                                    <td className="ticket-cell"><FaTicketAlt className="me-1 ticket-icon" />{ticket}</td>
                                                    <td className="cashback-amt">{cashback}</td>
                                                    <td><span className={`cb-badge cb-badge-${sBg}`}>{status}</span></td>
                                                    <td><button className="row-action" aria-label="More options"><FaEllipsisH /></button></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>

                        {/* Quick Access */}
                        <Col xl={4} lg={12}>
                            <div className="cb-card h-100">
                                <div className="cb-card-header mb-3">
                                    <div>
                                        <h4 className="cb-card-title">Quick Access</h4>
                                        <span className="cb-card-sub">Manage reward activities</span>
                                    </div>
                                </div>
                                <div className="qa-grid">
                                    {QUICK_ACTIONS.map(({ label, Icon, cls }, i) => (
                                        <button key={i} className={`qa-btn ${cls}`}>
                                            <span className="qa-icon-wrap"><Icon /></span>
                                            <span className="qa-label">{label}</span>
                                            <FaAngleRight className="qa-arrow" />
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </Col>

                    </Row>

                </Container>
            </div>
        </>
    );
}